import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import Dropdown from './Dropdown'

const actions = {
  googleAnalyticsEvent,
}

export default connect(state => ({ mobileBrowser: state.app.mobileBrowser }), actions)(Dropdown)
